export const getTipTopPosition = (area, width, imgWidth) => {
    // Calculate correct coordinates
    const q = imgWidth / width
    const coords = area.coords.map(c => c / q)
    if (!area) return { top: 0, left: 0 };
    // Calculate centroid
    const n = coords.length / 2;
    const { y, x } = coords.reduce(({ y, x }, val, idx) => {
        // If top left Y coordinates
        if (idx === 1) return { y: val, x }
        // All other cases
        return !(idx % 2) ? { y, x: x + (val / n) } : { y: y < val ? y : val, x };
    }, { y: 0, x: 0 });
    return { top: `${y}px`, left: `${x}px` };
}

export const getTipCenterPosition = (area, width, imgWidth) => {
    // Calculate correct coordinates
    const q = imgWidth / width
    const coords = area.coords.map(c => c / q)
    if (!area) return { top: 0, left: 0 };
    // Calculate centroid
    const n = coords.length / 2;
    const { y, x } = coords.reduce(({ y, x }, val, idx) => {
        return !(idx % 2) ? { y, x: x + (val / n) } : { y: y + (val / n), x };
    }, { y: 0, x: 0 });
    return { top: `${y}px`, left: `${x}px` };
}



// WEBPACK FOOTER //
// ./src/utils/interactiveMap.js